// routes
import { PATH_DASHBOARD } from "../../../routes/paths";
// components
import SvgColor from "../../../components/svg-color";

// ----------------------------------------------------------------------

const icon = (name: string) => (
  <SvgColor
    src={`/assets/icons/navbar/${name}.svg`}
    sx={{ width: 1, height: 1 }}
  />
);

const ICONS = {
  user: icon("ic_user"),
  ecommerce: icon("ic_ecommerce"),
  analytics: icon("ic_analytics"),
  dashboard: icon("ic_dashboard"),
};

const navConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    subheader: "",
    items: [
      {
        title: "Dashboard",
        path: PATH_DASHBOARD.dashboard,
        icon: ICONS.dashboard,
      },
      {
        title: "Users",
        path: PATH_DASHBOARD.users,
        icon: ICONS.dashboard,
      },
      {
        title: "Deposits",
        path: PATH_DASHBOARD.deposits,
        icon: ICONS.dashboard,
      },
      {
        title: "Currency",
        path: PATH_DASHBOARD.currency,
        icon: ICONS.dashboard,
      },
      {
        title: "Withdrawals",
        path: PATH_DASHBOARD.withdraw,
        icon: ICONS.dashboard,
      },
      {
        title: "Rewards",
        path: PATH_DASHBOARD.reward,
        icon: ICONS.dashboard,
      },
      {
        title: "Claimed Rewards",
        path: PATH_DASHBOARD.ClaimedRewards,
        icon: ICONS.dashboard,
      },
      {
        title: "My Commissions",
        path: PATH_DASHBOARD.commissions,
        icon: ICONS.dashboard,
      },
      {
        title: "Settings",
        path: PATH_DASHBOARD.settings,
        icon: ICONS.dashboard,
      },
    ],
  },
];

export default navConfig;
